import { HttpHeaders } from '@angular/common/http';

/**
 * Utility class for HTTP headers management
 */
export class HttpHeadersUtil {
  /**
   * Prepare default headers for HTTP requests
   * @returns Object with headers configured
   */
  static prepareDefaultHeaders(): { headers: HttpHeaders } {
    let headers = new HttpHeaders();
    headers = headers.set('Accept', 'application/json');
    return { headers };
  }

  /**
   * Prepare headers with custom content type
   * @param contentType - Content type to set
   * @returns Object with headers configured
   */
  static prepareHeadersWithContentType(contentType: string): { headers: HttpHeaders } {
    let headers = new HttpHeaders();
    headers = headers.set('Accept', 'application/json');
    headers = headers.set('Content-Type', contentType);
    return { headers };
  }

  /**
   * Prepare headers with custom additional headers
   * @param additionalHeaders - Record of additional headers to add
   * @returns Object with headers configured
   */
  static prepareCustomHeaders(additionalHeaders: Record<string, string>): { headers: HttpHeaders } {
    let headers = new HttpHeaders();
    headers = headers.set('Accept', 'application/json');

    Object.keys(additionalHeaders).forEach(key => {
      headers = headers.set(key, additionalHeaders[key]);
    });

    return { headers };
  }
}
